module.exports = __webpack_public_path__ + "media/images/Branding/HW Mark Red-5e95be5afccbf1959e05fd8951ac057a.png";